import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { noop } from '../../helpers';
import Theme from '../../theme';

const SCAnchor = styled.a`
  color: ${Theme.colours.linkblue};
  text-decoration: none;
  cursor: pointer;
  outline: 0;

  &[disabled] {
    color: ${Theme.colours.grey_cc};
    cursor: default;
  }

  &:not([disabled]) {
    &:hover {
      color: ${Theme.colours.bluehover};
      text-decoration: none;
    }
  }

  font-family: ${props =>
    props.secondary
      ? Theme.fonts.families.AvenirBook
      : Theme.fonts.families.AvenirHeavy};
`;

class Anchor extends Component {
  render() {
    return (
      <SCAnchor
        className={this.props.className}
        id={this.props.id}
        href={this.props.href}
        role={this.props.role}
        aria-label={this.props.ariaLabel}
        target={this.props.target}
        title={this.props.title}
        tabIndex={this.props.tabIndex}
        onClick={this.handleClick.bind(this)}
        disabled={this.props.disabled}
        secondary={this.props.secondary}
      >
        {this.props.children}
      </SCAnchor>
    );
  }

  handleClick(e) {
    if (!this.props.disabled) {
      this.props.onClick(e);
    }
  }
}

Anchor.defaultProps = {
  onClick: noop,
  disabled: false,
  secondary: false
};

Anchor.propTypes = {
  /** Anchor text */
  children: PropTypes.node,
  /** Secondary style anchor */
  secondary: PropTypes.bool,
  /** Extra class to apply to element */
  className: PropTypes.string,
  /** ID of anchor */
  id: PropTypes.string,
  /** The link for the anchor tag */
  href: PropTypes.string,
  /** Set the role of the anchor */
  role: PropTypes.string,
  /** Set the aria label */
  ariaLabel: PropTypes.string,
  /** Set the target of the link */
  target: PropTypes.string,
  /** Add a title to the link */
  title: PropTypes.string,
  /** Set the tab index */
  tabIndex: PropTypes.number,
  /** Event to fire when component is clicked */
  onClick: PropTypes.func,
  /** Disable anchor */
  disabled: PropTypes.bool
};

export default Anchor;
